/* eslint-disable @nx/enforce-module-boundaries */
import { useRouter } from 'next/router';
import { forwardRef, useEffect } from 'react';
import { JobsListingMySavedPage } from './saved';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { useSelector } from 'react-redux';

export const JobsListingMyPage = forwardRef(({ ...props }, ref) => {
  const { replace, asPath } = useRouter();
  const { userProfileInfo } = useSelector((state) => state.userProfile);

  const trackMyJobsPageVisit = () => {
    const userSlug = userProfileInfo?.slug;
    if (!userSlug) return;

    trackEvent(ANALYTICS_EVENTS.MyJobs, userSlug, {
      page_path: asPath,
      page_title: 'My Jobs',
      redirect_to: '/jobs/my/saved',
      timestamp: new Date().toISOString()
    });
  };

  useEffect(() => {
    if (userProfileInfo) {
      trackMyJobsPageVisit();
      replace('/jobs/my/saved', undefined, { shallow: true });
    }
  }, []);
  
  return (
    <AuthenticatedProviders>
        <JobsListingMySavedPage />
      </AuthenticatedProviders>
    );
});

export default JobsListingMyPage;
